import store from '@/store';
import {
  CLEAR_ACCOUNT_ISLOADING,
  CLEAR_ANNOUNCEMENT_ISLOADING,
  CLEAR_DONATION_ISLOADING,
  CLEAR_EVENT_ISLOADING,
  CLEAR_ORGANIZATION_ISLOADING,
  CLEAR_RECENT_PHOTO_ISLOADING,
  CLEAR_SCREEN_ISLOADING,
  CLEAR_TEMPLATE_ISLOADING,
  CLEAR_YURTZEITEN_DESIGN_N_ISLOADING,
  CLEAR_YURTZEITEN_EMAIL_TEMPLATE_ISLOADING,
  CLEAR_YURTZEITEN_ISLOADING,
  CLEAR_WEEKLY_SCHEDULE_N_ISLOADING,
  CLEAR_ZMANIM_ISLOADING,
} from '@/store/action_types';

export const resetLoaders = () => {
  store.dispatch(CLEAR_ACCOUNT_ISLOADING);
  store.dispatch(CLEAR_ANNOUNCEMENT_ISLOADING);
  store.dispatch(CLEAR_EVENT_ISLOADING);
  store.dispatch(CLEAR_DONATION_ISLOADING);
  store.dispatch(CLEAR_ORGANIZATION_ISLOADING);
  store.dispatch(CLEAR_RECENT_PHOTO_ISLOADING);
  store.dispatch(CLEAR_SCREEN_ISLOADING);
  store.dispatch(CLEAR_TEMPLATE_ISLOADING);
  store.dispatch(CLEAR_YURTZEITEN_ISLOADING);
  store.dispatch(CLEAR_YURTZEITEN_EMAIL_TEMPLATE_ISLOADING);
  store.dispatch(CLEAR_YURTZEITEN_DESIGN_N_ISLOADING);
  store.dispatch(CLEAR_WEEKLY_SCHEDULE_N_ISLOADING);
  store.dispatch(CLEAR_ZMANIM_ISLOADING);
};
